// extracted by mini-css-extract-plugin
export default {"disclaimer":"_3Sj74y9G05hLsPPXY2jvIQ=="};